import { request } from '../@utils'
const Service = {
  getDepartmentTree: async () => await request.get('common/department/tree'),
  getRoleList: async req => await request.post('auth/role/list', { data: req }),
  getRoleDetail: async id => await request.get(`auth/role/info/${id}`),
  getPermissionsTree: async () =>
    await request.get('auth/role/permission/tree'),
  create: async (req) => await request.post('auth/role/create', {data: req}),
  update: async (req) => await request.post('auth/role/update', {data: req}),
  delete: async id => await request.delete(`auth/role/delete/${id}`),
}

export default Service
